import { useEffect, useRef, useState } from 'react';

export default function MediaQuery({ children, query }) {
  const mqlRef = useRef(window.matchMedia(query));
  const [matches, setMatches] = useState(() => mqlRef.current.matches);

  useEffect(() => {
    const mql = mqlRef.current;
    const onChange = event => setMatches(event.matches);

    mql.addListener(onChange);

    return () => mql.removeListener(onChange);
  }, [mqlRef]);

  return matches ? children : null;
}
